var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-row',[_c('v-col',{attrs:{"cols":"12","md":"12"}},[_c('AppPageContainer',{attrs:{"title":"Sample Page"}},[_c('div',{staticClass:"pa-7 pt-1"})])],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }